export * from './menu-principal.component';